import './session-add.scss';

import { searchUser } from '~modules/user/api';
import { UserHelper } from '~modules/user/model';
import { CheckBox, InputSuggest, PhotoMake, PhotoPreview, Preloader } from '~shared/ui';

import { useAddSession } from './use-add-session.ts';

export function SessionAdd() {
	const { pending, user, setUser, photo, setPhoto, clearPhoto, create, errors, is_part_time, setPartTime } =
		useAddSession();

	return (
		<div className="session-add">
			<h1>Создать смену</h1>
			{pending ? (
				<Preloader />
			) : (
				<>
					<div className="row vcenter">
						<div className="col col--90">
							<InputSuggest
								placeholder="Сотрудник"
								value={user}
								onSearch={searchUser}
								onChange={setUser}
								stringify={val => (val ? UserHelper.getName(val) : null)}
								error={errors.user}
							/>
						</div>
						<div className="col col--15">
							<CheckBox checked={is_part_time} label="Подработка" onChange={setPartTime} />
						</div>
					</div>
					<div className="row">
						{photo ? (
							<PhotoPreview photo={photo} onClear={clearPhoto} onCreate={create} />
						) : (
							<PhotoMake onCreate={setPhoto} />
						)}
						{errors.photo && <div className="error">{errors.photo}</div>}
					</div>
				</>
			)}
		</div>
	);
}
